import { SelectItem } from 'ui/common/select/types';
import { getSubOptionTypeValue } from 'app/components/filters/filters-panel/option-type-value';
import { valuePropName } from 'app/components/filters/filters-panel/constants';
import { SubOptionTypes, ConditionValueTypes, Filter } from 'app/components/filters/types';
import { getTextFieldConditionTypesValueData } from 'app/components/filters/filters-panel/filter-types/filter-text/text-field-data';
import { trimValue } from '../trim-value';

export const createConditionSubOptionTypeValue = (id: number, filter: Filter, value: SelectItem[]) => {
  const subOptionTypes = getSubOptionTypeValue(filter);
  const mapped = subOptionTypes && subOptionTypes.length > 0 && subOptionTypes.map(subOptionType => {
    return {
      [SubOptionTypes.MatchExact]: ConditionValueTypes.matchExact
    }[subOptionType];
  });

  const trimmedValue = trimValue(value);
  const newValue = value ? {
    [valuePropName.text]: trimmedValue
  } : {};

  const newConditionValue = trimmedValue && filter.advancedField && {
    id,
    ...newValue,
    myValue: false,
    periodPredef: { v: 0 },
    ...getTextFieldConditionTypesValueData(filter.advancedField, undefined, mapped)
  };

  return trimmedValue && subOptionTypes && subOptionTypes.length > 0 && [newConditionValue];
};
